import { render, staticRenderFns } from "./PanelHeading.vue?vue&type=template&id=f0717834"
import script from "./PanelHeading.vue?vue&type=script&lang=js"
export * from "./PanelHeading.vue?vue&type=script&lang=js"
import style0 from "./PanelHeading.vue?vue&type=style&index=0&id=f0717834&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports